import React, {SyntheticEvent, useEffect, useState} from "react";
import {Select} from 'antd';
import {SelectionMode} from '@models/index';
import personFetcherHoc from "@hocs/personFetcherHoc";
import {FormattedMessage} from 'react-intl';
import {Person} from "@models/person";


const Option = Select.Option;


type SelectionValue = string | string[] | null


type PersonSelectionProps = {
    mode: SelectionMode,
    onChange?: (value: SelectionValue) => void
    value: SelectionValue
    data: Person[],
    onScroll: (e: SyntheticEvent) => void,
    handleSearch: (query: string) => void,
    onFocus: () => void,
    selectedPerson: Person | null
}

const Selection: React.FC<PersonSelectionProps> = props => {
    const {handleSearch, onScroll, data = [], onChange, onFocus, selectedPerson, disabled} = props;
    const [value, setValue] = useState(null);

    //the selected items should be in the data of select to show correctly
    const list = selectedPerson && !data.find(opt => opt.id == selectedPerson.id) ? [...data, selectedPerson] : data;

    useEffect(() => {
        if (selectedPerson) {
            setValue(selectedPerson.id)
        }
    }, [props.selectedPerson]);

    const handleChange = value => {
        setValue(value);
        onChange && onChange(data.find(item => item.id == value));
    };

    return (
        <Select
            showSearch
            disabled={disabled}
            mode={'default'}
            value={value}
            defaultActiveFirstOption={false}
            showArrow={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            onFocus={onFocus}
            onPopupScroll={onScroll}
            notFoundContent={null}
            placeholder={<FormattedMessage id="app.select_person" defaultMessage={`Select Person`}/>}
        >
            {list.map((d, index) => <Option value={d.id} key={index}>{d.name}</Option>)}

        </Select>
    )
};


export default personFetcherHoc(Selection);
